import { render, staticRenderFns } from "./Top-Reports-Group.vue?vue&type=template&id=141161f5&"
import script from "./Top-Reports-Group.vue?vue&type=script&lang=js&"
export * from "./Top-Reports-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports